import { useEffect, useState } from "react";
import { getContentVersions } from "@/lib/apiClient";
import { History } from "lucide-react";

export function ScriptVersions({ script, onLoad }) {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { setList(null); setOpen(false); }, [script.id]);
  const toggle = () => {
    if (!open && list === null) getContentVersions(script.id).then(setList).catch(() => setList([]));
    setOpen(!open);
  };
  const load = (v) => {
    if (!window.confirm(`Versie van ${new Date(v.at).toLocaleString("nl-NL")} in de editor laden? Er wordt pas iets opgeslagen als je op 'Belscript opslaan' klikt.`)) return;
    onLoad(v.doc);
  };
  return (
    <div className="rounded-2xl border border-[#E2E7EC] bg-white p-4" data-testid="script-versions">
      <button data-testid="script-versions-toggle" onClick={toggle} className="inline-flex items-center gap-2 text-sm font-medium text-[#001C51]">
        <History className="h-4 w-4" /> Versiegeschiedenis {open ? "verbergen" : "tonen"}
      </button>
      {open && (
        <div className="mt-3 space-y-1.5">
          {list === null ? <p className="text-xs text-[#5B6675]">Laden…</p> : list.length === 0 ? (
            <p className="text-xs text-[#5B6675]" data-testid="script-versions-empty">Nog geen eerdere versies. Bij elke opslag wordt de vorige versie hier bewaard.</p>
          ) : list.map((v, i) => (
            <div key={i} className="flex items-center gap-3 text-xs" data-testid={`script-version-${i}`}>
              <span className="text-[#16202B] font-medium">{new Date(v.at).toLocaleString("nl-NL")}</span>
              <span className="text-[#5B6675]">{v.by} · {v.action === "update" ? "vóór wijziging" : v.action === "delete" ? "vóór verwijderen" : "vóór reset"}</span>
              <button data-testid={`script-version-load-${i}`} onClick={() => load(v)} className="ml-auto px-2.5 py-1 rounded-lg border border-[#E2E7EC] text-[#001C51] hover:bg-[#EDF1F5]">In editor laden</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
